export const urlToExcelData = (url: string): any => ({
    url,
    file: undefined,
});

export const fileToExcelData = (file: File): any => ({
    url: URL.createObjectURL(file),
    file,
});
